import { takeEvery, put, call } from "redux-saga/effects";

// Login Redux States
import {
  LOGIN_USER,
  LOGOUT_USER,
  VERIFY_2F,
  VERIFY_2F_LOGIN,
  SEND_VERIFICATION_CODE,
  SEND_VERIFICATION_CODE_SUCCESS
} from "./actionTypes";
import { loginApiError } from "./actions";

//Include Both Helper File with needed methods

import {
  postLogin,
  postVerify2fSecret,
  postVerify2fLogin,
  postsendVerificationCode
} from "../../../helpers/backend_helper/backend_helper";


function* loginUser({ payload: { user, history } }) {
  try {
    localStorage.setItem("username", user.username);
    localStorage.setItem("enteredPassword", user.password);

    const response = yield call(postLogin, {
      username: user.username,
      password: user.password,
    });

    const authUser = Object.keys(response);

    authUser.forEach((item, idx) => localStorage.setItem(item, response[item]));

    localStorage.setItem("username", response.userName);
    localStorage.setItem("phone", response.phone);
    localStorage.setItem("otpDatetime", response.otpDatetime);
    
    localStorage.setItem("Act",response.accessToken);
    history.push("/auth-two-step-verification");
  } catch (error) {
    yield put(loginApiError(error));
  }
}

function* verify2fCode({ payload: { verify, history } }) {
  try {
    const response = yield call(postVerify2fSecret, {
      username: localStorage.getItem("username"),
      password: localStorage.getItem("enteredPassword"),
      verificationCode: verify.verificationCode,
      QrString: verify.QrString,
    });

    Object.keys(response).forEach((item, idx) =>
      item !== "accessToken" || item !== "enteredPassword" || item !== "password" ? localStorage.setItem(item, response[item]) : null,
    );

    let username = localStorage.getItem("username");
    localStorage.setItem("authUser", [{ "fng": "val" }]);
    localStorage.setItem("username", username);
    history.push("/Dashboard");
  } catch (error) {
    yield put(loginApiError(error));
  }
}

function* verify2fLogin({ payload: { verify, history } }) {
  try {
    const response = yield call(postVerify2fLogin, {
      username: localStorage.getItem("username"),
      password: localStorage.getItem("enteredPassword"),
      twoFactorSecret: "",
      verificationCode: verify.verificationCode,
      otpDatetime: localStorage.getItem("otpDatetime"),
    });

    // Object.keys(response).forEach((item, idx) =>
    //   localStorage.setItem(item, response[item])
    // );
    let username = localStorage.getItem("username");
    let tempLang = localStorage.getItem("I18N_LANGUAGE");
    let tempLang2 = localStorage.getItem("i18nextLng");
    // localStorage.clear();

    localStorage.setItem("I18N_LANGUAGE", tempLang);
    localStorage.setItem("i18nextLng", tempLang2);
    localStorage.setItem("authUser", [{ "fng": "val" }]);
    localStorage.setItem("username", username);
    localStorage.setItem("password", null);
    localStorage.setItem("enteredPassword", null);
    // localStorage.setItem("authUser", JSON.stringify(response));

    history.push("/Dashboard");
  } catch (error) {
    yield put(loginApiError(error));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    let tempLang = localStorage.getItem("I18N_LANGUAGE");
    let tempLang2 = localStorage.getItem("i18nextLng");
    localStorage.clear();

    localStorage.setItem("I18N_LANGUAGE", tempLang);
    localStorage.setItem("i18nextLng", tempLang2);

    history.push("/login");
  } catch (error) {
    yield put(loginApiError(error));
  }
}

function* sendVerificationCode({ payload: { history } }) {
  try {
    const response = yield call(postsendVerificationCode, {
      username: localStorage.getItem("username"),
      password: localStorage.getItem("enteredPassword"),
      otpDatetime: localStorage.getItem("otpDatetime"),
      twoFactorSecret: ""
    });

    const authUser = Object.keys(response);

    authUser.forEach((item, idx) => item !== "accessToken" || item !== "enteredPassword" || item !== "password" ? localStorage.setItem(item, response[item]) : null);

    localStorage.setItem("username", response.userName);
    localStorage.setItem("phone", response.phone);
    localStorage.setItem("otpDatetime", response.otpDatetime);

  } catch (error) {
    yield put(loginApiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(VERIFY_2F, verify2fCode);
  yield takeEvery(VERIFY_2F_LOGIN, verify2fLogin);
  yield takeEvery(SEND_VERIFICATION_CODE, sendVerificationCode);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
